import remote from '../remote'

const state = {
  trucks: []
}

const getters = {
  TRUCKS: state => {
    return state.trucks
  },
  TRUCKS_BY_ID: (state, getters) => (id) => {
    return state.trucks.find(truck => truck.id === id)
  },
  TRUCKS_AS_RESOURCES: (state) => {
    return state.trucks.filter(truck => truck.data.inActive !== true).map((truck, index) => (
      {
        id: truck.id.toString(),
        sortOrder: index,
        groupId: truck.ObjectDescription.name,
        title: truck.data.regnbr
      }
    ))
  },
  TRUCKS_TANKBIL_AS_RESOURCES: (state) => {
    return state.trucks.filter(truck => truck.data.inActive !== true && truck.ObjectDescription.name === 'Tankbil').map((truck, index) => (
      {
        id: truck.id,
        sortOrder: index,
        groupId: truck.ObjectDescription.name,
        title: truck.data.regnbr
      }
    ))
  }
}

const mutations = {
  SET_TRUCKS: (state, payload) => {
    state.trucks = payload
  }
}

const actions = {
  GET_TRUCKS: async (context, payload) => {
    const { data } = await remote().get('/api/objectdatas/getVehiclesForPlanning/2')
    context.commit('SET_TRUCKS', data)
  }
}

export default {
  state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/modules/vehicles.js